import { OpenBankingAccount } from '@features/openBanking/types/openBankingAccount'
import { isOpenBankingAccountDeleted } from '@features/openBanking/utils/isOpenBankingAccountDeleted'

export const getActiveOpenBankingAccounts = (accounts: OpenBankingAccount[] = []): OpenBankingAccount[] =>
  accounts.filter((account) => !isOpenBankingAccountDeleted(account))

// Mirrors getOpenBankingAccountStatus (Bank Accounts page), so every flagged account has a renew action there
export const getUnhealthyOpenBankingAccounts = (accounts: OpenBankingAccount[] = []): OpenBankingAccount[] =>
  getActiveOpenBankingAccounts(accounts).filter(({ connection, isOrphaned }) => connection.requiresUpdate || isOrphaned)
